/**
 * Client Startup Validator
 * Validates environment, storage, API availability, and CMS state before React mounts.
 */

import { getPublicCMSDirect } from '../lib/supabase';

export interface StartupValidationResult {
  ok: boolean;
  module: string;
  details?: string;
}

export async function validateClientStartup(): Promise<StartupValidationResult[]> {
  const results: StartupValidationResult[] = [];

  // 1. Storage & Environment Check
  try {
    const testKey = '__startup_test__';
    localStorage.setItem(testKey, '1');
    localStorage.removeItem(testKey);
    results.push({ ok: true, module: 'Local Storage & Browser API' });
    console.log('[Startup Validation] [✓] Local Storage & Browser API ready');
  } catch (err: any) {
    results.push({ ok: false, module: 'Local Storage & Browser API', details: err.message });
    console.error('[Startup Validation] [❌] Local Storage check failed:', err);
  }

  // 2. Auth Session Readiness
  try {
    const token = localStorage.getItem('token');
    results.push({ ok: true, module: 'Authentication State', details: token ? 'Token stored' : 'Guest session' });
    console.log('[Startup Validation] [✓] Auth State initialized');
  } catch (err: any) {
    results.push({ ok: false, module: 'Authentication State', details: err.message });
  }

  // 3. CMS & Supabase / API Reachability
  try {
    const cmsData = await getPublicCMSDirect();
    if (cmsData) {
      results.push({ ok: true, module: 'Supabase CMS & Data Provider' });
      console.log('[Startup Validation] [✓] Supabase CMS connected');
    } else {
      results.push({ ok: true, module: 'Supabase CMS', details: 'Using fallback default CMS configuration' });
    }
  } catch (err: any) {
    results.push({ ok: true, module: 'Supabase CMS', details: 'Offline mode / default state fallback' });
    console.warn('[Startup Validation] [⚠️] Supabase connection fallback:', err.message);
  }

  return results;
}
